type NavigateFn = (path: string) => void

let navigateFn: NavigateFn | null = null

export function setWebNavigate(fn: NavigateFn | null) {
  navigateFn = fn
}

export function webNavigate(path: string) {
  navigateFn?.(path)
}
